// import {PrivateInterceptors} from "../../../../Base/interceptors/PrivateInterceptor";
import { PublicInterceptor } from "../../../../Base/interceptors/PublicInterceptor";


// export const getProveedoresActivos = async () => {
//     const result = await PrivateInterceptors('proveedores/proveedoresActivos', 'GET');
//     return result;
// }


// OBTENER LISTADO DE PROVEEDORES
// export const getProveedores = async () => {
//     const result = await PrivateInterceptors(`Proveedores`, 'GET');
//     return result;
// }

// OBTENER ENLACE DE INSCRIPCION DE UN PROVEEDOR
// export const getEnlaceInscripcion = async (IdCustomer) => {
//     const result = await PrivateInterceptors(`Proveedores/LinkInscripcion`, 'POST', {IdCustomer});
//     return result;
// }

// GUARDAR INSCRIPTION DE PROVEEDOR
export const saveInscripcionProveedor = async (Company, token) => {
    const result = await PublicInterceptor(`Proveedores/InscripcionProveedor`, 'PUT', Company, token);
    return result;
}
// OBTIENER INFORMACION DE UN PROVEEDOR
export const getProveedorInfo = async(IdCustomer, token) => {
    const result = await PublicInterceptor(`Proveedores/getProveedor`, 'POST',IdCustomer, token )
    return result;
}

// ACTUALIZAR ESTADO DE EDICION DEL ENLACE DE INSCRIPCION DEL PROVEEDOR 
// export const updateEnlaceInscripcion = async (body) => {
//     const result = await PrivateInterceptors(`Proveedores/actualizarEstadoEdicion`, 'PUT', body);
//     return result;
// }

// GET ARCHIVOS DE PROVEEDOR
export const getArchivoProveedor = async (file, IdCustomer, token = localStorage.getItem('ppfToken')) => {
    const result = await PublicInterceptor(`Proveedores/${file}/${IdCustomer}`, 'GET', undefined, token);
    return result;///
}

// GUARDAR ARCHIVO FORMATO INSCRIPCION
export const saveArchivoFormatoInscripcion = async (FormatoInscripcion, IdCustomer, FormatoInscripcionName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FormatoInscripcion/${IdCustomer}`, 'PUT', {FormatoInscripcion, FormatoInscripcionName}, token);
    return result;
}

// OBTENER ARCHIVO FORMATO INSCRIPCION
export const getArchivoFormatoInscripcion = async (IdCustomer, token = localStorage.getItem('ppfToken')) => {
    const result = await PublicInterceptor(`Proveedores/FormatoInscripcion/${IdCustomer}`, 'GET', undefined, token);
    return result;
}

// GUARDAR FILE BIC
export const saveArchivoBIC = async (BIC, IdCustomer, BICName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileBIC/${IdCustomer}`, 'PUT', {FileBIC: BIC, BICName: BICName}, token);
    return result;
}

// GUARDAR FILE CONSTANCIA DE PAGOS A CUENTA
export const saveArchivoConstanciaPagos = async (ConstanciaPagos, IdCustomer, ConstanciaPagosName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileConstanciaPagos/${IdCustomer}`, 'PUT', {FileConstPagosCuenta: ConstanciaPagos, ConstPagosName: ConstanciaPagosName}, token);
    return result;
}

// GUARDAR FILE ESCRITURA DE CONSTITUCION
export const saveArchivoEscrituraConstitucion = async (EscrituraConstitucion, IdCustomer, EscrituraConstitucionName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileEscrituraConstitucion/${IdCustomer}`, 'PUT', {FileEscrituraConstitucion: EscrituraConstitucion, EscrituraConstitucionName: EscrituraConstitucionName}, token);
    return result;
}

// GUARDAR FILE PERMISO DE OPERACIONES
export const saveArchivoPermisoOperaciones = async (PermisoOperaciones, IdCustomer, PermisoOperacionesName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FilePermisoOperaciones/${IdCustomer}`, 'PUT', {FilePermisoOperaciones: PermisoOperaciones, PermisoOperacionesName: PermisoOperacionesName}, token);
    return result;
}

// GUARDAR FILE REGISTRO DEXONERADO
export const saveArchivoRegistroDexonera = async (RegistroDexonera, IdCustomer, RegistroDexoneraName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileRegistroExonerado/${IdCustomer}`, 'PUT', {FileRegistroExonerado: RegistroDexonera, RegistroExoneradoName: RegistroDexoneraName}, token);
    return result;
}

// GUARDAR FILE REGISTRO DEXONERADO
export const saveArchivoFactura = async (Factura, IdCustomer, FacturaName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileFactura/${IdCustomer}`, 'PUT', {FileFactura: Factura, FacturaName: FacturaName}, token);
    return result;
}

// GUARDAR REGISTRO EXONERADO
export const saveRegistroExonerado = async (datos, token) => {
  const result = await PublicInterceptor(`Proveedores/AgregarRegistroExonerado`, 'POST', { datos }, token);
  return result;
};

// GUARDAR FILE Pasaporte/Certificado
export const saveArchivoCertificado = async (Certificado, IdCustomer, CertificadoName, token ) => {
    const result = await PublicInterceptor(`Proveedores/FileCertificado/${IdCustomer}`, 'PUT', {FileCertificado: Certificado, CertificadoName: CertificadoName}, token);
    return result;
}

// export const getArchivoProveedor2 = async (file, IdCustomer, token = localStorage.getItem('ppfToken')) => {
//     const result = await PublicInterceptor(`Proveedores/${file}2/${IdCustomer}`, 'GET', undefined, token);
//     return result;
// }


export const getArchivo = async (IdCustomer, token = localStorage.getItem('ppfToken')) => {
    const result = await PublicInterceptor(`Proveedores/getArchvivoProveedor/${IdCustomer}`, 'GET', undefined, token);
    return result;
}

// export const getArchivoConstPagos = async (IdCustomer, token = localStorage.getItem('ppfToken')) => {
//     const result = await PublicInterceptor(`Proveedores/getArchvivoConstPagos/${IdCustomer}`, 'GET', undefined, token);
//     return result;
// }

